import { FormFieldTypes } from "../../../../../components/finalForms/libs/data/formFieldType"

const initialState = {
    sContractName1: "",
    sContractBillName2: "",
    sContractAddr1: "",
    sContractAddr2: "",
    sContractZip: "",
    sContractCity: "",
    sContractState: "",
    sContractPhoneNumber: "",
    sBillEmailName: "",
    sBillEmail: "",
    sContractFaxNumber: "",
    bShowShippingAddressOnInvoice: false,
    billTypeEmail: false,
    billTypeAddress: false,
}

export const addressFieldConfig = {
    name: "Add Department",
    initialState: initialState,
    section: [

        {
            sectionId: "billingAddressSection",
            title: "Billing Address Section",
            row: {},
            style: {
                sectionStyle: "col-lg-6 col-md-6 pr-5",
            },
            wrapperTemplate: <div className="form-card address-main-sec row"></div>, // Wrapper HTML or Component
            fields: [
                {
                    id: "billingAddressSection",
                    label: "",
                    fieldType: FormFieldTypes.MAINFORMTITLE,
                    fieldSetting: {
                        formTitle: "Billing Address",
                    },
                    style: {
                        containerCss: "col-lg-12 col-md-12",
                    },
                },
                {
                    id: "billTypeAddress",
                    label: "Address",
                    Field_Name: "bill Type Address",
                    fieldType: FormFieldTypes.CHECKBOX,
                    dataField: "billTypeAddress",
                    fieldSetting: {
                        placeholder: "  ",
                        subTitle: "Bill Type :",
                    },
                    style: {
                        containerCss:
                            "col-xxl-4 col-xl-4 col-lg-4 col-4 mb-2 double-label-sec mt-3",
                    },
                },
                {
                    id: "billTypeEmail",
                    label: "Email",
                    Field_Name: "Type Email",
                    fieldType: FormFieldTypes.CHECKBOX,
                    dataField: "billTypeEmail",
                    style: {
                        containerCss: "col-xxl-4 col-xl-4 col-lg-6 col-12 mb-2 mt-3",
                    },
                },

                {
                    id: "sContractName1",
                    label: "Name :",
                    Field_Name: "Name",
                    fieldType: FormFieldTypes.INPUT,
                    dataField: "sContractName1",
                    fieldSetting: {
                        placeholder: "Enter Client Name 1",
                    },
                    validation: [{ type: "require" }, { type: "text" }],
                    style: {
                        containerCss: "col-12 mb-2",
                    },
                },
                {
                    id: "sContractBillName2",
                    label: "    ",
                    Field_Name: "Client",
                    fieldType: FormFieldTypes.INPUT,
                    dataField: "sContractBillName2",
                    fieldSetting: {
                        placeholder: "Enter Client Name 2",
                    },
                    style: {
                        containerCss: "col-12 mb-2",
                    },
                },
                {
                    id: "sContractAddr1",
                    label: "Address Line 1 :",
                    Field_Name: "Address Line 1",
                    fieldType: FormFieldTypes.INPUT,
                    dataField: "sContractAddr1",
                    fieldSetting: {
                        placeholder: "Enter Address Line 1",
                    },
                    style: {
                        containerCss: "col-12 mb-2",
                    },
                },
                {
                    id: "sContractAddr2",
                    label: "Address Line 2 :",
                    Field_Name: "Address Line 2",
                    fieldType: FormFieldTypes.INPUT,
                    dataField: "sContractAddr2",
                    fieldSetting: {
                        placeholder: "Enter Address Line 2",
                    },
                    style: {
                        containerCss: "col-12 mb-2",
                    },
                },
                {
                    id: "sContractZip",
                    label: "Zip/City/State :",
                    Field_Name: "Zip",
                    fieldType: FormFieldTypes.INPUT,
                    dataField: "sContractZip",
                    fieldSetting: {
                        placeholder: "Enter Zip",
                        isEnableOnChange: true,
                    },
                    style: {
                        containerCss: "col-xxl-4 col-lg-5 mb-2 pr-0",
                    },
                },
                {
                    id: "sContractCity",
                    label: "",
                    Field_Name: "City",
                    fieldType: FormFieldTypes.INPUT,
                    dataField: "sContractCity",
                    fieldSetting: {
                        placeholder: "Enter City",
                    },
                    style: {
                        containerCss: "col-xxl-5 col-lg-4 mb-2 pr-0 validation-left-0",
                    },
                },
                {
                    id: "sContractState",
                    label: "",
                    Field_Name: "State",
                    fieldType: FormFieldTypes.SELECT,
                    dataField: "sContractState",
                    fieldSetting: {
                        placeholder: "Select State",
                        options: [],
                        isLoading: false,
                    },
                    style: {
                        containerCss: "col-xxl-3 col-lg-3 mb-2 validation-left-0",
                    },
                },
                {
                    id: "sBillEmailName",
                    label: "Email Name : ",
                    Field_Name: "email address",
                    fieldType: FormFieldTypes.INPUT,
                    dataField: "sBillEmailName",
                    fieldSetting: {
                        placeholder: "Enter Email Name",
                        allowSpace: true,
                    },
                    style: {
                        containerCss: "col-md-9 mb-2",
                    },
                },
                {
                    id: "sBillEmail",
                    label: "Email Address : ",
                    Field_Name: "email address",
                    fieldType: FormFieldTypes.INPUT,
                    dataField: "sBillEmail",
                    fieldSetting: {
                        placeholder: "Enter Email Address",
                        allowSpace: true,
                    },
                    style: {
                        containerCss: "col-md-9 mb-2",
                    },
                },
                {
                    id: "sContractPhoneNumber",
                    label: "Phone :",
                    Field_Name: "Phone",
                    fieldType: FormFieldTypes.PHONE,
                    dataField: "sContractPhoneNumber",
                    fieldSetting: {
                        placeholder: "(000)-000-0000",
                        defaultCountry: "us",
                    },
                    style: {
                        containerCss: "col-md-9 mb-2",
                    },
                },
                {
                    id: "sContractFaxNumber",
                    label: "Fax :",
                    Field_Name: "Fax :",
                    fieldType: FormFieldTypes.MASKINPUT,
                    dataField: "sContractFaxNumber",
                    fieldSetting: {
                        placeholder: "Enter Fax Number",
                        allowSpace: false,
                        masking: {
                            isMasking: true,
                            showMask: true,
                            maskFormat: '(___) ___-____',
                            maskPlaceholder: "",
                            maskReplacement: { _: /\d/ }
                        },
                    },
                    style: {
                        containerCss: "col-md-9 mb-2",
                    },
                },
            ],
        },
        {
            sectionId: "shippingAddressSection",
            title: "Shipping Address Section",
            row: {},
            style: {
                sectionStyle: "col-lg-6 col-md-6  pl-5",
            },
            wrapperTemplate: <div className="form-card address-main-sec row"></div>, // Wrapper HTML or Component
            fields: [

                {
                    id: "shippingAddressSection",
                    label: "",
                    formTitle: "Shipping Address",
                    fieldType: FormFieldTypes.MAINFORMTITLE,
                    fieldSetting: {
                        formTitle: "Shipping Address",
                    },
                    style: {
                        containerCss: "col-lg-12 col-md-12",
                    },
                },
                {
                    id: "bShippingSameAsBilling",
                    label: "Same As Billing",
                    Field_Name: "bill Type Address",
                    fieldType: FormFieldTypes.CHECKBOX,
                    dataField: "bShippingSameAsBilling",
                    fieldSetting: {
                        placeholder: "  ",
                        hasMainTitle: "Bill Type :",
                    },
                    style: {
                        containerCss:
                            "col-xxl-12 col-xl-12 col-lg-12 col-12 mb-2 double-label-sec mt-3",
                    },
                },
                {
                    id: "bShowShippingAddressOnInvoice",
                    label: "Show on Invoice",
                    Field_Name: "Type Email",
                    fieldType: FormFieldTypes.CHECKBOX,
                    dataField: "bShowShippingAddressOnInvoice",
                    style: {
                        containerCss: "col-xxl-12 col-xl-12 col-lg-12 col-12 mb-2 mt-0",
                    },
                },
                {
                    id: "sContractShippingName1",
                    label: "Name :",
                    Field_Name: "sContractShippingName1",
                    fieldType: FormFieldTypes.INPUT,
                    dataField: "sContractShippingName1",
                    fieldSetting: {
                        placeholder: "Enter Client Name 1",
                    },
                    validation: [{ type: "require" }, { type: "text" }],
                    style: {
                        containerCss: "col-12 mb-2",
                    },
                },
                {
                    id: "sContractShippingName2",
                    label: "    ",
                    Field_Name: "sContractShippingName2",
                    fieldType: FormFieldTypes.INPUT,
                    dataField: "sContractShippingName2",
                    fieldSetting: {
                        placeholder: "Enter Client Name 2",
                    },
                    style: {
                        containerCss: "col-12 mb-2",
                    },
                },
                {
                    id: "sContractShippingAddr1",
                    label: "Address Line 1 :",
                    Field_Name: "sContractShippingAddr1",
                    fieldType: FormFieldTypes.INPUT,
                    dataField: "sContractShippingAddr1",
                    fieldSetting: {
                        placeholder: "Enter Address Line 1",
                    },
                    style: {
                        containerCss: "col-12 mb-2",
                    },
                },
                {
                    id: "sContractShippingAddr2",
                    label: "Address Line 2 :",
                    Field_Name: "sContractShippingAddr2",
                    fieldType: FormFieldTypes.INPUT,
                    dataField: "sContractShippingAddr2",
                    fieldSetting: {
                        placeholder: "Enter Address Line 2",
                    },
                    style: {
                        containerCss: "col-12 mb-2",
                    },
                },
                {
                    id: "sContractShippingZip",
                    label: "Zip/City/State :",
                    Field_Name: "sContractShippingZip",
                    fieldType: FormFieldTypes.INPUT,
                    dataField: "sContractShippingZip",
                    fieldSetting: {
                        placeholder: "Enter Zip",
                        isEnableOnChange: true,
                        isLoading: false,
                    },
                    style: {
                        containerCss: "col-xxl-4 col-lg-5 mb-2 pr-0",
                    },
                },
                {
                    id: "sContractShippingCity",
                    label: "",
                    Field_Name: "sContractShippingCity",
                    fieldType: FormFieldTypes.INPUT,
                    dataField: "sContractShippingCity",
                    fieldSetting: {
                        placeholder: "Enter City",
                    },
                    style: {
                        containerCss: "col-xxl-5 col-lg-4 mb-2 pr-0 validation-left-0",
                    },
                },
                {
                    id: "sContractShippingState",
                    label: "",
                    Field_Name: "sContractShippingState",
                    fieldType: FormFieldTypes.SELECT,
                    dataField: "sContractShippingState",
                    fieldSetting: {
                        placeholder: "Select State",
                        options: [],
                        isLoading: false,
                    },
                    style: {
                        containerCss: "col-xxl-3 col-lg-3 mb-2 validation-left-0",
                    },
                },
                {
                    id: "sContractShippingPhoneNumber",
                    label: "Phone :",
                    Field_Name: "sContractShippingPhoneNumber",
                    fieldType: FormFieldTypes.PHONE,
                    dataField: "sContractShippingPhoneNumber",
                    fieldSetting: {
                        placeholder: "(000)-000-0000",
                        defaultCountry: "us",
                        isDisable: false,
                    },
                    style: {
                        containerCss: "col-md-9 mb-2",
                    },
                },
                {
                    id: "sContractShippingFaxNumber",
                    label: "Fax :",
                    Field_Name: "sContractShippingFaxNumber",
                    fieldType: FormFieldTypes.MASKINPUT,
                    dataField: "sContractShippingFaxNumber",
                    fieldSetting: {
                        placeholder: "Enter Fax Number",
                        allowSpace: false,
                        masking: {
                            isMasking: true,
                            showMask: true,
                            maskFormat: '(___) ___-____',
                            maskPlaceholder: "",
                            maskReplacement: { _: /\d/ },
                        },
                    },
                    style: {
                        containerCss: "col-md-9 mb-2",
                    },
                },
            ]
        }
    ],
}